// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('oeeDashBoard', {
//         templateUrl: 'views/components/views/oeeDashBoard/oeeDashBoard.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['oeeDashBoardService', function (oeeDashBoardService) {
            
//             // #region VARIABLES & DEFINITIONS
            
//             const vm = this;
//             let reload;
            
//             vm.model = {
//                 itemsListOeeDashboard: []
//             };
            
//             // #endregion VARIABLES & DEFINITIONS
            
//             // #region LOAD PROCEDURE FUNCTION CALLS
            
//             async function loadOeeDashboard() {
//                 vm.model.itemsListOeeDashboard = await oeeDashBoardService.listOeeDashboard();
//             }
            
//             // #endregion LOAD PROCEDURE FUNCTION CALLS
            
//             // #region RELOAD INTERVAL FUNCTION
            
//             function reloadInterval() {
//                 oeeDashBoardService.reloadOeeDashboard();
//                 loadOeeDashboard();
//             }
            
//             // #endregion RELOAD INTERVAL FUNCTION
            
//             // #region ON INIT FUNCTION
            
//             vm.$onInit = async function () {
//                 loadOeeDashboard();
//                 reload = setInterval(reloadInterval, 30000);
//             }
            
//             // #endregion ON INIT FUNCTION
            
//             // #region ON DESTROY FUNCTION
            
//             vm.$onDestroy = function () {
//                 clearInterval(reload);
//             }
            
//             // #endregion ON DESTROY FUNCTION
            
//         }]
//     });
// })();
